module.exports = __webpack_public_path__ + "PTMETTAabout-3.7044928c.png";